import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { ColorPickerField } from "./ColorPickerField";
import { bgStyle } from "../lib/bgStyle";

/**
 * Background editor for a TV zone: color + opacity (0–100%) + optional image URL.
 * The preview swatch on the right shows exactly how the zone background will look
 * (with transparency over a checker pattern).
 */
export const ZoneBgEditor = ({ label, prefix, colors, onChange }) => {
  const colorKey = `${prefix}Bg`;
  const opacityKey = `${prefix}BgOpacity`;
  const imageKey = `${prefix}BgImage`;
  const color = colors[colorKey] || "#FFFFFF";
  const opacity = colors[opacityKey] ?? 1;
  const image = colors[imageKey] || "";

  return (
    <div className="border border-border/60 p-4 mb-4">
      <div className="text-xs uppercase tracking-[0.25em] text-foreground/70 font-bold mb-3">{label}</div>

      <ColorPickerField
        label="Cor de fundo"
        value={color}
        onChange={(v) => onChange({ [colorKey]: v })}
        testId={`zonebg-${prefix}-color`}
      />

      <div className="flex items-center justify-between gap-4 py-2 border-b border-border/40">
        <Label className="text-sm uppercase tracking-[0.18em] font-medium text-foreground/80">
          Opacidade
        </Label>
        <div className="flex items-center gap-3 flex-1 max-w-xs">
          <input
            type="range"
            min="0"
            max="100"
            value={Math.round(opacity * 100)}
            onChange={(e) => onChange({ [opacityKey]: Number(e.target.value) / 100 })}
            className="flex-1 cursor-pointer accent-foreground"
            data-testid={`zonebg-${prefix}-opacity-slider`}
          />
          <span className="font-mono text-xs w-10 text-right">{Math.round(opacity * 100)}%</span>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4 py-2 border-b border-border/40">
        <Label className="text-sm uppercase tracking-[0.18em] font-medium text-foreground/80 shrink-0">
          Imagem (URL)
        </Label>
        <Input
          value={image}
          onChange={(e) => onChange({ [imageKey]: e.target.value })}
          placeholder="https://… (opcional)"
          className="flex-1 max-w-xs font-mono text-xs"
          data-testid={`zonebg-${prefix}-image-input`}
        />
      </div>

      <div className="mt-3 flex items-center gap-3">
        <span className="text-xs text-foreground/60 uppercase tracking-[0.18em]">Preview:</span>
        <div
          className="w-20 h-12 border border-border rounded relative overflow-hidden"
          style={{
            backgroundImage:
              "linear-gradient(45deg, #ddd 25%, transparent 25%), linear-gradient(-45deg, #ddd 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ddd 75%), linear-gradient(-45deg, transparent 75%, #ddd 75%)",
            backgroundSize: "12px 12px",
            backgroundPosition: "0 0, 0 6px, 6px -6px, -6px 0px",
          }}
        >
          <div className="absolute inset-0" style={bgStyle(color, opacity, image)} />
        </div>
      </div>
    </div>
  );
};
